// src/layouts/AdminSidebar.jsx
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { handleAdminLogout } from '../utils/Logout';

export default function AdminSidebar() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);

  const menu = [
    { name: 'Dashboard', path: '/admin/dashboard' },
    { name: 'Users', path: '/admin/users' },
    { name: 'Transactions', path: '/admin/transactions' },
    { name: 'Support', path: '/admin/support' },
    { name: 'Settings', path: '/admin/settings' },
  ];

  return (
    <div
      className={`h-screen bg-black text-white flex flex-col transition-all duration-300 ${
        collapsed ? 'w-16' : 'w-64'
      }`}
    >
      <div className="flex items-center justify-between p-4">
        <h1 className={`text-xl font-bold ${collapsed ? 'hidden' : 'block'}`}>
          Admin
        </h1>
        <button
          onClick={() => setCollapsed(!collapsed)}
          className="text-white hover:text-gray-400"
        >
          {collapsed ? '➡️' : '⬅️'}
        </button>
      </div>

      <nav className="flex-1 flex flex-col space-y-2 px-2">
        {menu.map((item) => (
          <Link
            key={item.name}
            to={item.path}
            className={`px-3 py-2 rounded transition ${
              pathname === item.path ? 'bg-white text-black' : 'hover:bg-gray-800'
            } ${collapsed ? 'text-center px-1' : ''}`}
            title={collapsed ? item.name : ''}
          >
            {collapsed ? item.name.charAt(0) : item.name}
          </Link>
        ))}
      </nav>

      <div className="p-4 border-t border-gray-700">
        <button
          onClick={() => handleAdminLogout(navigate)}
          className="w-full text-left text-sm text-red-400 hover:text-red-200"
        >
          {collapsed ? '🚪' : 'Logout'}
        </button>
      </div>
    </div>
  );
}